import {
  api_cancel_team_subscription_path,
  api_confirm_group_subscription_path,
  api_create_gift_subscription_path,
  api_create_team_members_subscriptions_path,
  api_email_validation_path,
  api_group_subscriptions_path,
  api_team_subscription_path,
  api_update_group_subsciption_path,
  api_validate_gift_recipient_path,
} from '../../routes';
import { GROUP_SUBSCRIPTION_GIFT, GROUP_SUBSCRIPTION_TEAM } from '../../src/constants';
import request from './request';
import { TeamResponse } from './teams';

export const GROUP_SUBSCRIPTION_KEY = 'group_subscription_key';
export type GroupSubscriptionType = typeof GROUP_SUBSCRIPTION_TEAM | typeof GROUP_SUBSCRIPTION_GIFT;

export interface GroupSubscriptionRecipientsParams {
  type: GroupSubscriptionType;
}
export interface GroupSubscriptionRecipient {
  email: string;
  paidThroughDate: string;
  autoRenew: boolean;
  recipientId: number;
}

export interface GroupSubscriptionConfirmParams {
  group_subscription_type: GroupSubscriptionType;
  emails?: string[];
}

export interface GroupSubscriptionConfirmResponse {
  totalPrice: number;
  subscribeThroughDate: string;
  unitPrice: number;
  totalEligibleSubs?: number;
}

export interface UpdateGroupSubscriptionParams {
  auto_renew: boolean;
  recipient_id: number;
}

export interface UpdateGroupSubscriptionResponse {
  message: string;
}

export interface ValidateRecipientResponse {
  success: boolean;
}

export interface CreateTeamSubscriptionParams {
  guid: string;
  email?: string;
}

export interface CancelTeamSubscriptionParams {
  recipient_id: number;
}

export interface CancelTeamSubscriptionResponse {
  message?: string;
  success: boolean;
}

export interface CreateGiftSubscriptionParams {
  emails: string;
  notes: string;
  auto_renew: boolean;
}

export interface CreateGiftSubscriptionResponse {
  message: string;
  code?: string;
}

export interface ValidateGiftRecipientParams {
  email: string;
}

export interface CurrentOffer {
  initialPrice: number;
  discountedPercentageOff: number;
}

// Shared
export async function getGroupSubscriptionRecipients(
  params: GroupSubscriptionRecipientsParams
): Promise<GroupSubscriptionRecipient[]> {
  const resp = await request('get', api_group_subscriptions_path(params));
  return resp?.recipients;
}

export async function validateRecipientEmail(email: string): Promise<ValidateRecipientResponse> {
  const resp = await request('get', api_email_validation_path({ email }));
  return resp;
}

export async function confirmGroupSubscription(
  params: GroupSubscriptionConfirmParams
): Promise<GroupSubscriptionConfirmResponse> {
  const resp = await request('get', api_confirm_group_subscription_path(params));
  return resp;
}

export async function updateGroupSubscription(
  params: UpdateGroupSubscriptionParams
): Promise<UpdateGroupSubscriptionResponse> {
  const resp = await request('put', api_update_group_subsciption_path(params));
  return resp;
}

// Teams
export async function createTeamSubscription(
  params: CreateTeamSubscriptionParams
): Promise<UpdateGroupSubscriptionResponse> {
  const resp = await request('post', api_team_subscription_path(params));
  return resp;
}

export async function createTeamMembersSubscriptions(values: string[]): Promise<TeamResponse> {
  const resp = await request('post', api_create_team_members_subscriptions_path(), {
    team: { emails: values },
  });
  return resp;
}

export async function cancelTeamSubscription(
  params: CancelTeamSubscriptionParams
): Promise<CancelTeamSubscriptionResponse> {
  const resp = await request('put', api_cancel_team_subscription_path(params));
  return resp;
}

// Gifts
export async function createGiftSubscription(
  params: CreateGiftSubscriptionParams
): Promise<CreateGiftSubscriptionResponse> {
  const resp = await request('post', api_create_gift_subscription_path(params));
  return resp;
}

export async function validateGiftRecipient(
  params: ValidateGiftRecipientParams
): Promise<ValidateRecipientResponse> {
  const resp = await request('get', api_validate_gift_recipient_path(params));
  return resp;
}
